import React from 'react';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import styles from 'components/faceted-search/FacetPill.css';

const FacetPill = ({ displayName, labels, onClick, onRemove }) =>
  <div className={styles.container}>
    <div
      className={
        onClick ? styles.innerContainer : styles.innerContainerDisabled
      }
      onClick={onClick}
    >
      {labels.length > 1
        ? <span className={styles.facetLabelStrong}>
            {displayName}&nbsp;
          </span>
        : <span className={styles.facetLabel}>
            {displayName}:&nbsp;
          </span>}

      {labels.length > 1
        ? <span className={styles.numTerms}>
            ({labels.length})
          </span>
        : <span className={styles.term}>
            "{labels[0]}"
          </span>}
    </div>
    <FontIcon value="cancel" className={styles.icon} onClick={onRemove} />
  </div>;

export default FacetPill;
